import cx from 'classnames';

export const Container = ({children, className = ''}) => (
  <div
    id="create-container"
    className={cx({
      'create-container': true,
      [className]: !!className,
    })}
  >
    {children}
  </div>
);
